export default __webpack_public_path__ + "static/media/login-GS-logo-snga.075d1a4c.png";